import { render } from "./UserManagementView.vue?vue&type=template&id=9ed54cf8&scoped=true"
import script from "./UserManagementView.vue?vue&type=script&lang=js"
export * from "./UserManagementView.vue?vue&type=script&lang=js"

import "./UserManagementView.vue?vue&type=style&index=0&id=9ed54cf8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ed54cf8"]])

export default __exports__